import {Component, Input, OnInit} from '@angular/core';
import {Favorite} from '@models/favorite';

@Component({
    selector: 'app-taux-proprietaire',
    templateUrl: './taux-proprietaire.component.html',
    styleUrls: ['./taux-proprietaire.component.scss']
})
export class TauxProprietaireComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;

    constructor() {
    }

    ngOnInit() {
    }

}
